export enum AiFeedbackProblemType {
  Other = 0,
  IncorrectAnswer = 1,
  IncompleteAnswer = 2,
  Irrelevant = 3,
  Offensive = 4,
  Slow = 5,
  InformationSecurityConsent = 6,
}
